export const lineGraph = {
  'chart': {
    'type': 'line',
    'height': 300
  },
  'credits': {
    enabled: false
  },
  'title': {
    'text': ''
  },
  'subtitle': {
    'text': ''
  },
  'plotOptions': {
    'series': {
      'animation': true,
      style: { fontFamily: '\'Open Sans\', sans-serif' }
    }
  },
  'yAxis': {
    style: { fontFamily: '\'Open Sans\', sans-serif' },
    'title': {
      'text': ''
    },
    labels: {
      style: {
        fontFamily: '\'Open Sans\', sans-serif'
      }
    }
  },
  'xAxis': {
    style: { fontFamily: '\'Open Sans\', sans-serif' },
    'type': 'datetime',
    'dateTimeLabelFormats': {
      'day': '%b %e',
      'week': '%b %e',
      'month': '%b \'%y',
      'year': '%Y'
    },
    labels: {
      format: '{value:%b %e}',
      style: {
        fontFamily: '\'Open Sans\', sans-serif'
      }
    }
  }
};
